<template>
  <nav>
    <v-navigation-drawer :app="app" permanent :clipped="clipped" light width="320">
      <v-row class="fill-height" no-gutters>
        <v-list class="grow">
          <v-subheader>Chapters</v-subheader>
          <template v-for="(item, index) in help">
            <v-list-item :key="index" :to="item.route" :exact="item.exact" :class="`pl-${item.depth * 6}`">
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-row>
    </v-navigation-drawer>
  </nav>
</template>
<script>
export default {
  name: "Navbar",
  props: {
    app: { type: Boolean, default: true },
    mini: { type: Boolean, default: true },
    clipped: { type: Boolean, default: true }
  },
  data() {
    return {
      menu: [
        { title: 'Home', icon: 'mdi-home', route: 'home', exact: true, },
        { title: 'Files', icon: 'mdi-file-document', route: 'fileList', exact: false },
        { title: 'Datasets', icon: 'mdi-database', route: 'datasetList', exact: false },
        { title: 'Predictions', icon: 'mdi-finance', route: 'predictionList', exact: false },
        { title: 'Exports', icon: 'mdi-file-export-outline', route: 'exportList', exact: false },
        { title: 'Applications', icon: 'mdi-apps', route: 'applicationList', exact: false },
        { title: 'Agents', icon: 'mdi-run-fast', route: 'agentList', exact: false },
      ],
      help: [
        { title: 'Introduction', route: '/help', depth: 1, exact: true },
        { title: 'Files', route: '/help/files', depth: 1, exact: false },
        { title: 'Datasets', route: '/help/datasets', depth: 1, exact: false },
        { title: 'Predictions', route: '/help/predictions', depth: 1, exact: false },
        { title: 'Applications', route: '/help/applications', depth: 1, exact: true },
        { title: 'Production Forecasting', route: '/help/applications/forecasting', depth: 2, exact: false },
        { title: 'About', route: '/help/about', depth: 1, exact: false },
        { title: 'Credits', route: '/help/credits', depth: 1, exact: false },
        { title: 'Release Notes', route: '/help/release_notes', depth: 1, exact: false },
      ],
    }
  },
}
</script>
